import { Modal } from "antd";
import axios from "axios";
import * as sdk from "microsoft-cognitiveservices-speech-sdk";
import s3Controller from "./s3Controller";
// const FileSaver = require("file-saver");

const backend = process.env.REACT_APP_BACKEND;
const key = process.env.REACT_APP_AZURE_KEY;
const region = process.env.REACT_APP_AZURE_REGION;

function textToFile(text, name, speed, fileName, path, callback) {
  const ssml =
    '<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xml:lang="en-US">' +
    name +
    speed +
    text +
    "</prosody>" +
    "</voice>" +
    "</speak>";

  const speechConfig = sdk.SpeechConfig.fromSubscription(key, region);

  //   speechConfig.speechSynthesisOutputFormat =
  //     sdk.SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3;

  let synthesizer = new sdk.SpeechSynthesizer(speechConfig, null);
  //   synthesizer.speakTextAsync(
  synthesizer.speakSsmlAsync(
    ssml,
    (result) => {
      if (result.reason === sdk.ResultReason.SynthesizingAudioCompleted && result.audioData.byteLength > 1000) {
        const audioData = result.audioData;
        const blob = new Blob([audioData], { type: "audio/mpeg" });
        const file = new File([blob],fileName)

        s3Controller.s3Upload(file,path,callback)
      } else {
        console.error("Speech synthesis canceled, " + result.errorDetails +
            "\nDid you set the speech resource key and region values?");
        callback(result.errorDetails,null)
      }
      synthesizer.close();
      synthesizer = null;
    },
    (error) => {
      console.log(error);
      synthesizer.close();
      synthesizer = null;
    }
  );
}

export default textToFile;
